
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/terms-of-sale",
      function () {
        return require("private-next-pages/policies/terms-of-sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/terms-of-sale"])
      });
    }
  